<template>
  <component
    :is="modalComponent"
    :coupon="coupon"
  />
</template>

<script>
import CONSTANTS from '@/constants/constants';
import RedeemModal from './RedeemModal.vue';
import QRCodeModal from './QRCodeModal.vue';
import BarcodeModal from './BarcodeModal.vue';

export default {
  name: 'CouponCta',

  components: {
    RedeemModal,
    QRCodeModal,
    BarcodeModal,
  },

  props: {
    coupon: { type: Object, default: () => {}, required: true }, // coupon object
  },

  computed: {
    ctaType() {
      return this.coupon.cta || CONSTANTS.couponCtaTypes.redeem.value;
    },

    modalComponent() {
      return {
        [CONSTANTS.couponCtaTypes.redeem.value]: 'RedeemModal',
        [CONSTANTS.couponCtaTypes.buy.value]: null, // opens link instead of modal
        [CONSTANTS.couponCtaTypes.info.value]: null, // opens link instead of modal,
        [CONSTANTS.couponCtaTypes.qrCode.value]: 'QRCodeModal',
        [CONSTANTS.couponCtaTypes.barcode.value]: 'BarcodeModal',
      }[this.ctaType];
    },
  },
};
</script>
